import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/delcareProject',
  redirect: 'noredirect',
  name: 'declare',
  component: Layout,
  children: [
    {
      path: 'delcareProject',
      component: () => import('@/views/delcareProject/index.vue'),
      name: 'delcareProject',
      meta: {
        title: '数据申报',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
